// extracted by mini-css-extract-plugin
export var modal = "_uo-0";
export var table = "_uo-1";